<template>
  <div>
    <!-- 面包屑导航区 -->
    <!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>农场管理</el-breadcrumb-item>
      <el-breadcrumb-item>土特产列表</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入内容"
            v-model="queryInfo.query"
            clearable
            @clear="getSpecialtyList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getSpecialtyList"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="goAddPage">添加土特产</el-button>
        </el-col>
      </el-row>
      <!-- 表格数据 -->
      <el-table :data="specialtyList" border stripe>
        <!-- <el-table-column type="index"></el-table-column> -->
        <el-table-column
          label="土特产名称"
          width="150px"
          prop="name"
        ></el-table-column>
        <el-table-column label="土特产图片" width="125px">
          <template slot-scope="scope"
            ><img :src="scope.row.image" width="100px" height="100px"
          /></template>
        </el-table-column>
        <el-table-column label="土特产价格(元)" width="150px">
          <template slot-scope="scope">
            {{ $round(scope.row.price) }}
          </template>
        </el-table-column>
        <el-table-column label="土特产规格" width="150px">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{
              scope.row.specification
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="土特产介绍">
          <template slot-scope="scope">{{
            scope.row.description
              ? scope.row.description.substring(0, 10) + "..."
              : "--"
          }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="180px">
          <template slot-scope="scope">{{
            scope.row.create_time | dataFormat
          }}</template>
        </el-table-column>
        <el-table-column label="状态" width="180px">
          <template slot-scope="scope">
            <el-tag type="success" size="mini" v-if="scope.row.status"
              >已上架</el-tag>
            <el-tag type="danger" size="mini" v-else>已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300px" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status"
              type="danger"
              icon="el-icon-down"
              size="mini"
              @click="updateStatus(scope.row.id, 0)"
              >下架</el-button
            >
            <el-button
              v-if="!scope.row.status"
              type="success"
              icon="el-icon-up"
              size="mini"
              @click="updateStatus(scope.row.id, 1)"
              >上架</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="editInfo(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>
    <el-dialog
      :title="isEdit ? '修改土特产信息' : '添加土特产信息'"
      :visible.sync="editDialogVisible"
      width="50%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <AddSpecialty
        :detail="currentDetail"
        :isEdit="isEdit"
        @refreshList="refreshList"
        @close="editDialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { farm_SpecialtyList } from "@/config/config.js";
import AddSpecialty from "./Add.vue";
export default {
  components: {
    AddSpecialty,
  },
  data() {
    return {
      queryInfo: {
        query: "",
        page: 1,
        limit: 10,
        status: -1,
      },
      // 土特产列表
      specialtyList: [],
      // 土特产总数
      total: 0,
      editDialogVisible: false,
      currentDetail: null,
      isEdit: false,
      farmList: [],
    };
  },
  created() {
    this.getSpecialtyList();
  },
  methods: {
    refreshList() {
      this.getSpecialtyList();
      this.editDialogVisible = false;
    },
    // 根据分页获取对应的土特产列表
    async getSpecialtyList() {
      let params = _.cloneDeep(this.queryInfo);
      params.page--;
      const { data: res } = await this.$http.get("web_api/canteen/foods", {
        params,
      });
      if (res.code !== 200) {
        return this.$message.error("获取列表失败！");
      }
      this.specialtyList = res.data;
      this.total = res.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.getSpecialtyList();
    },
    handleCurrentChange(newSize) {
      this.queryInfo.page = newSize;
      this.getSpecialtyList();
    },
    // 通过Id删除土特产
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该土特产, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除！");
      }
      const { data: res } = await this.$http.post("web_api/canteen/deleteFood", {
        id
      });
      if (res.code !== 200) {
        return this.$message.error("删除土特产失败！");
      }
      this.$message.success("删除土特产成功！");
      this.getSpecialtyList();
    },
    goAddPage() {
      this.isEdit = false;
      this.currentDetail = null;
      this.editDialogVisible = true;
    },
    async updateStatus(id, flag) {
      const confirmResult = await this.$confirm(
        `是否确认${flag == 0 ? "下架" : "上架"},?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消操作！");
      }
      const { data: res } = await this.$http.post("web_api/specialty/updateStatus", {
        id,
        status: flag,
      });
      if (res.code !== 200) return this.$message.error("更新土特产状态失败！");
      this.$message.success("更新土特产状态成功!");
      this.getSpecialtyList();
    },
    editInfo(current) {
      this.isEdit = true;
      this.currentDetail = current;
      this.editDialogVisible = true;
    },
    closeDialog() {
      this.isEdit = false;
      this.currentDetail = null;
      this.editDialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
